module.exports = function getResource(label, vars = []) {
    const resources = { newText: 'NOUVEAUTÉ' };
    return resources[label];
};
